import { gsap } from "gsap";
import lottie from 'lottie-web'
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
var grandmother = document.querySelector('.magazine--grandmother');

console.log(lang)


if (grandmother) {
  var lang = document.documentElement.lang;
  gsap.registerPlugin(ScrollTrigger)

  if lang == 'de' {
    let playhead = {frame: 0},
        animation = lottie.loadAnimation({
          container: document.querySelector(".lottie--grandmother-bank-de"),
          renderer: "svg",
          loop: false,
          autoplay: false,
          path: "/assets/BOE_22_003_Friendship-Bench_scrollanimation_de_230316.json"
        });

      } else {
        let playhead = {frame: 0},
            animation = lottie.loadAnimation({
              container: document.querySelector(".lottie--grandmother-bank"),
              renderer: "svg",
              loop: false,
              autoplay: false,
              path: "/assets/BOE_22_003_Friendship-Bench_scrollanimation_230316.json"
            });

      }




  animation.addEventListener("DOMLoaded", function() {
    let tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".grandmother-animation",
          start: "top 25%", // when the top of the trigger hits the top of the viewport
          end: "bottom bottom",
          // markers: true,
          scrub: true // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        }
      });
  });


    let tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".grandmother-animation",
          start: "top 25%", // when the top of the trigger hits the top of the viewport
          end: "bottom bottom",
          // markers: true,
          scrub: true // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        }
      });

    tl.from(".grandmother-animation__section--1", {})
      .to(playhead, {
        frame: 200,
        duration: 3,
        ease: "none",
        onUpdate: () => animation.goToAndStop(playhead.frame, true),
      })




  // PIN ANIMATION
  gsap.to(".grandmother-animation", {
    scrollTrigger: {
      trigger: ".grandmother-animation",
      // markers: true,
      start: "top 25%",
      end: "bottom bottom",
      pin: ".lottie--grandmother-pin",
      scrub: 1,
    },
  });



}


